import { render, staticRenderFns } from "./fccProjetosEquipeDesenvolvimento.vue?vue&type=template&id=a731d5a4"
import script from "./fccProjetosEquipeDesenvolvimento.vue?vue&type=script&lang=js"
export * from "./fccProjetosEquipeDesenvolvimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports